import { render, staticRenderFns } from "./industrialChain.vue?vue&type=template&id=5e3c6aa6&scoped=true&"
import script from "./industrialChain.vue?vue&type=script&lang=js&"
export * from "./industrialChain.vue?vue&type=script&lang=js&"
import style0 from "./industrialChain.vue?vue&type=style&index=0&id=5e3c6aa6&prod&scoped=true&lang=css&"
import style1 from "./industrialChain.vue?vue&type=style&index=1&id=5e3c6aa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c6aa6",
  null
  
)

export default component.exports